<template>
    <div class="modal fade" id="modal_add_announcement" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">

        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestAnnouncement" />
                <div class="modal-header">

                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ action == 'add' ? i18n.t('views.clients.announcements.add') :
                            i18n.t('views.clients.announcements.edit') }}
                    </h5>
                    <button @click="closeModal('modal_add_announcement', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestAnnouncement">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestAnnouncement.title" :label="i18n.t('tables.announcements.title')"
                                :v="v$.title" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestAnnouncement.content"
                                :label="i18n.t('tables.announcements.content')" :v="v$.content" :disabled="false" />
                        </div>


                        <SingleSelect :TextLabel="i18n.t('tables.announcements.mediaType')" :trackby="`name`"
                            :label="`name`" :valueProp="`name`" v-model="requestAnnouncement.mediaType"
                            :placeholder="`Type de media`" :arrayOptions="[{ name: 'image' }, { name: 'video' }]"
                            refs="mediaType" :v="v$.mediaType" />

                        <div v-if="requestAnnouncement.mediaType == 'image'" class="form-group mr-b-0em">
                            <input-image v-model="requestAnnouncement.media"
                                :label="i18n.t('tables.announcements.media')" :pathImage="image" :disabled="false" />
                        </div>
                        <div v-else-if="requestAnnouncement.mediaType == 'video'" class="form-group mr-b-0em">
                            <inputText v-model="requestAnnouncement.media" :label="i18n.t('tables.announcements.media')"
                                :v="v$.media" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestAnnouncement.start_date"
                                :label="i18n.t('tables.announcements.start_date')" :v="v$.start_date" :disabled="false"
                                :fixedDays="1" :isFixedDays="true" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestAnnouncement.end_date"
                                :label="i18n.t('tables.announcements.end_date')" :v="v$.end_date" :disabled="false" />
                        </div>
                        <SingleSelect :TextLabel="i18n.t('tables.announcements.isEnabled')" :trackby="`id`"
                            :label="`name`" :valueProp="`id`" v-model="requestAnnouncement.isEnabled"
                            :placeholder="`Type de media`"
                            :arrayOptions="[{ id: '1', name: 'Activer' }, { id: '0', name: 'Désactiver' }]"
                            refs="isEnabled" :v="v$.isEnabled" />
                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary mr-2">

                                {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                            </button>
                            <button type="button" @click="emptyState()" class="btn btn-cancel">

                                {{ i18n.t('button.clean') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, watch } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import inputFilter from "@/components/inputsValidation/inputFilter.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";

/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, helpers } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { useRouter } from 'vue-router'; // Import useRouter
/*composables & states */
import { useImageConverter } from '@/composables/global/useImageConverter';
import { useModal } from '@/composables/modal/useModal';

import { useAnnouncement } from "@/composables/announcement/useAnnouncement";
import { clubUUID } from "@/shared/state";
import { AnnouncementRequest } from "@/interfaces/announcement";
import { usePermission } from "@/composables/auth/usePermission";

export default defineComponent({
    components: { inputText, inputFilter, SingleSelect },
    name: "SomeComponent",
    props: {
        announcement: {
            type: Object,
            default: null,
        }
    },
    setup(props) {
        const action = ref('add')
        const { announcement } = toRefs(props);
        const { closeModal } = useModal();


        const requestAnnouncement = ref<AnnouncementRequest>({
            id: null,
            title: null,
            content: null,
            mediaType: 'image',
            media: null,
            start_date: null,
            end_date: null,
            isEnabled: null
        });
        const image = ref<any>(null)

        const { selectedImage, error, handleFileChange } = useImageConverter();
        const { addAnnouncement, editAnnouncement, isRequestAnnouncement, errorAnnouncement } = useAnnouncement();
        const { hasPermission } = usePermission();

        // Validation
        const rules = {
            title: {
                required: helpers.withMessage(i18n.t("validation.required"), required), String,
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            content: {
                required: helpers.withMessage(i18n.t("validation.required"), required), String,
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            mediaType: {
                required: helpers.withMessage(i18n.t("validation.required"), required),

            },
            media: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            start_date: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            end_date: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            isEnabled: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
        };
        const v$ = useVuelidate(rules, requestAnnouncement, { $scope: 'announcements' });

        /**
         * Add or edit announcement
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await addAnnouncement(requestAnnouncement.value);
                    if (!errorAnnouncement.value)
                        emptyState()
                } else {
                    Swal.fire({
                        title: i18n.t("message.confirmation.edit.title"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: i18n.t("button.edit"),
                        cancelButtonText: i18n.t("button.cancel"),
                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                        allowEscapeKey: false       // (optional) disable closing with ESC
                    }).then(async (result) => {
                        if (result.isConfirmed) {


                            if (action.value == "add") {
                                await addAnnouncement(requestAnnouncement.value)
                                if (!errorAnnouncement.value)
                                    closeModal('modal_add_announcement', 'add')


                            } else if (action.value == "edit") {
                                await editAnnouncement(requestAnnouncement.value)
                                if (!errorAnnouncement.value)
                                    closeModal('modal_add_announcement', 'add')
                            }

                        }
                    });
                }
            }
        }

        const emptyState = () => {
            action.value = 'add';
            requestAnnouncement.value.id = null
            requestAnnouncement.value.title = null
            requestAnnouncement.value.content = null
            requestAnnouncement.value.media = null
            requestAnnouncement.value.mediaType = 'image'
            requestAnnouncement.value.start_date = null
            requestAnnouncement.value.end_date = null
            requestAnnouncement.value.isEnabled = null
            image.value = null
            closeModal('modal_add_announcement', 'add')
            v$.value.$reset();
        };
        const initState = (announcement) => {

            if (announcement?.id) {
                action.value = 'edit';
                requestAnnouncement.value.id = announcement?.id || null
                requestAnnouncement.value.title = announcement?.title || null
                requestAnnouncement.value.content = announcement?.content || null
                requestAnnouncement.value.mediaType = announcement?.mediaType || 'image'
                requestAnnouncement.value.media = announcement?.media || null
                requestAnnouncement.value.start_date = announcement?.start_date || null
                requestAnnouncement.value.end_date = announcement?.end_date || null
                requestAnnouncement.value.isEnabled = announcement?.isEnabled || null
                image.value = announcement?.media ? announcement?.media : null
                v$.value.$reset();

            } else {
                emptyState()
            }
        };


        watch(
            () => selectedImage.value,
            (newValue) => {
                requestAnnouncement.value.media = selectedImage.value
                image.value = selectedImage.value ?? null
            });


        watch(
            () => announcement.value,
            (newValue) => {
                initState(announcement.value)

            });


        return {
            requestAnnouncement,
            submitForm,
            initState,
            emptyState,
            action,
            v$,
            i18n,
            image,
            hasPermission,
            isRequestAnnouncement,
            selectedImage,
            error,
            handleFileChange,
            closeModal
        };
    },
});
</script>
